import { render, staticRenderFns } from "./Expense.vue?vue&type=template&id=6d465d17"
import script from "./Expense.vue?vue&type=script&lang=js"
export * from "./Expense.vue?vue&type=script&lang=js"
import style0 from "./Expense.vue?vue&type=style&index=0&id=6d465d17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports